import React, { useEffect, useState } from "react";

import "Assets/styles/default/components/Product/CategoryBreadcrumb/CategoryBreadcrumb.less";

const CategoryBreadcrumb = ({ categoryHierarchy }) => {
  const [breadcumb, setBreadcumb] = useState([]);

  useEffect(() => {
    if (!categoryHierarchy) return;

    const { category } = categoryHierarchy;

    setBreadcumb([category.name, categoryHierarchy.name]);
  }, [categoryHierarchy]);

  return (
    <div className="category-breadcrumb-container">
      <div className="breadcrumb">
        {breadcumb.map((item, i) => <span className="item">{item}{i < (breadcumb.length - 1) ? ' / ' : ''}</span>)}
      </div>
    </div>
  );
}

export default CategoryBreadcrumb;